<template>
  <div class="flex items-center justify-center min-h-screen">
    <div class="text-center">
      <div class="spinner"></div>
      <p class="mt-4 text-gray-600">Completing login...</p>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // Get the provider from the URL
    const provider = window.location.pathname.split('/')[2];
    
    // Handle the SSO callback
    fetch(`/auth/${provider}/callback${window.location.search}`, {
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'success') {
          // If this was a new registration, track it with Facebook Pixel
          if (data.isNewRegistration && typeof fbq !== 'undefined') {
            // Track the registration event
            fbq('track', 'CompleteRegistration');
            
            // Get the event_id and send it to our server
            const event_id = fbq.getEventID();
            
            fetch('/api/facebook-pixel/track', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                event: 'CompleteRegistration',
                event_id: event_id,
                user_data: {
                  external_id: data.user.uuid,
                  em: data.user.email,
                  fn: data.user.name.split(' ')[0], // First name
                  ln: data.user.name.split(' ')[1] || '' // Last name
                }
              })
            });
          }
          
          // Redirect to the home page
          window.location.href = '/';
        } else {
          window.location.href = '/login';
        }
      })
      .catch(() => {
        window.location.href = '/login';
      });
  }
}
</script>

<style scoped>
.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
